import { useRef } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { useField } from 'formik';
import { Label, ErrorMessage, Input, Box } from '@qga/roo-ui/components';

const Field = ({ name, label, component: InputComponent, ...rest }) => {
  const id = useRef(uniqueId(`${name}_`)).current;
  const [inputProps, { error, touched }] = useField(name);
  const showError = !!(error && touched);

  return (
    <Box>
      <Label htmlFor={id} mb={2}>
        {label}
      </Label>

      <InputComponent {...inputProps} {...rest} error={showError} id={id} />

      {showError && (
        <ErrorMessage arrow="top" aria-live="assertive">
          {error}
        </ErrorMessage>
      )}
    </Box>
  );
};

Field.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

Field.defaultProps = {
  component: Input,
};

export default Field;
